module.exports = __webpack_public_path__ + "static/media/backSymbol.f78e8a05.svg";